import {JournalEntryApiDto} from "../../api/model/rest";
import AuthenticatedEntity from "../user/AuthenticatedEntity";
import JournalEntryItem from "./JournalEntryItem";
import {option, Option} from "ts-option";
import moment = require("moment");

export default class JournalEntry {

	constructor(public readonly id: string,
		public readonly creationDateTime: moment.Moment,
		public readonly creator: AuthenticatedEntity,
		public readonly date: moment.Moment,
		public readonly description: Option<string>,
		public readonly referenceNumber: string,
		public readonly items: JournalEntryItem[]) {}

	static fromJson(json: JournalEntryApiDto): JournalEntry {
		const creator = AuthenticatedEntity.fromJson(json.creator);
		const items = json.items.map(JournalEntryItem.fromJson);
		return new JournalEntry(json.id, moment(json.creationDateTime), creator, moment(json.date), option(json.description),
			json.reference, items);
	}
}
